import { render, staticRenderFns } from "./RequestUpdate.vue?vue&type=template&id=6ec067c7"
import script from "./RequestUpdate.vue?vue&type=script&lang=ts"
export * from "./RequestUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports